"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BrowserInfoFor3DS2 = void 0;
const class_transformer_1 = require("class-transformer");
const class_validator_1 = require("class-validator");
const type_graphql_1 = require("type-graphql");
// duplicated in packages/legacy-enums/src/legacy/CardPreregistrationAdditionalData.ts:1
let BrowserInfoFor3DS2 = class BrowserInfoFor3DS2 {
    acceptHeader;
    javaEnabled;
    language;
    colorDepth;
    screenHeight;
    screenWidth;
    timeZoneOffset;
    userAgent;
    javascriptEnabled;
};
exports.BrowserInfoFor3DS2 = BrowserInfoFor3DS2;
__decorate([
    (0, type_graphql_1.Field)({ nullable: true }),
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], BrowserInfoFor3DS2.prototype, "acceptHeader", void 0);
__decorate([
    (0, type_graphql_1.Field)(),
    (0, class_validator_1.IsBoolean)(),
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Boolean)
], BrowserInfoFor3DS2.prototype, "javaEnabled", void 0);
__decorate([
    (0, type_graphql_1.Field)(),
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], BrowserInfoFor3DS2.prototype, "language", void 0);
__decorate([
    (0, type_graphql_1.Field)(),
    (0, class_validator_1.IsNumber)(),
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Number)
], BrowserInfoFor3DS2.prototype, "colorDepth", void 0);
__decorate([
    (0, type_graphql_1.Field)(),
    (0, class_validator_1.IsNumber)(),
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Number)
], BrowserInfoFor3DS2.prototype, "screenHeight", void 0);
__decorate([
    (0, type_graphql_1.Field)(),
    (0, class_validator_1.IsNumber)(),
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Number)
], BrowserInfoFor3DS2.prototype, "screenWidth", void 0);
__decorate([
    (0, type_graphql_1.Field)(),
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], BrowserInfoFor3DS2.prototype, "timeZoneOffset", void 0);
__decorate([
    (0, type_graphql_1.Field)({ nullable: true }),
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], BrowserInfoFor3DS2.prototype, "userAgent", void 0);
__decorate([
    (0, type_graphql_1.Field)(),
    (0, class_validator_1.IsBoolean)(),
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Boolean)
], BrowserInfoFor3DS2.prototype, "javascriptEnabled", void 0);
exports.BrowserInfoFor3DS2 = BrowserInfoFor3DS2 = __decorate([
    (0, type_graphql_1.InputType)("BrowserInfoFor3DS2Input"),
    (0, class_transformer_1.Exclude)()
], BrowserInfoFor3DS2);
//# sourceMappingURL=BrowserInfoFor3DS2.js.map